import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0afb01f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "savedShops" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "goods-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "outer-sphere" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "text-size" }
const _hoisted_8 = { class: "text-size" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "standard" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_listEmpty = _resolveComponent("listEmpty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { title: "My Followed Store" }),
    _createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      "finished-text": $setup.storeListData.goods.length == 0?'':'No more products found～',
      "loading-text": "loading",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeListData.goods, (item1) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item1.store_id
          }, [
            _createElementVNode("div", {
              class: "page-goods-list",
              onClick: ($event: any) => ($setup.goStore(item1.store_id))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: item1.store_image_url.webpFilters()
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", {
                  class: "goods-name",
                  innerHTML: item1.store_name
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, "No. of Saved:" + _toDisplayString(item1.store_collect), 1),
                _createElementVNode("div", _hoisted_8, "Saved Time:" + _toDisplayString(item1.fav_time), 1),
                _hoisted_9
              ])
            ], 8, _hoisted_2)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "finished-text", "onLoad"]),
    (!$setup.loading && $setup.storeListData.goods.length == 0)
      ? (_openBlock(), _createBlock(_component_listEmpty, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}